import React, { ReactNode } from 'react';
import { Grid } from '@mui/material';

const PageBanner = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <Grid item xs='auto' id='banner-component'>
            {children}
        </Grid>
    );
};

export default PageBanner;
